import { render, staticRenderFns } from "./ScoreboardPage.vue?vue&type=template&id=76b2e9a6"
import script from "./ScoreboardPage.vue?vue&type=script&lang=js"
export * from "./ScoreboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports